if (!window.MediaRecorder) {
  import(/* webpackChunkName: "audio-recorder-polyfill" */ './handler').then(
    ({ default: AudioRecorder }) => {
      window.MediaRecorder = AudioRecorder
    },
  )
}
